import { StyleSheet } from 'aphrodite'

import headers from './headers'
import table from './table'
import approval from './approval'
import form from './form'
import ColorBlind from './ColorBlind'

export default {
  headers: StyleSheet.create(headers),
  table: StyleSheet.create(table),
  approval: StyleSheet.create(approval),
  form: StyleSheet.create(form),
  ColorBlind
}



// WEBPACK FOOTER //
// ./src/components/Community/Application/Main/style/index.js